<template>
<v-container fluid>
  <header-summary-table
    v-bind:classification="this.classification"
    v-bind:category="this.category">
    <v-simple-table>
      <thead>
        <tr>
          <th>
            ID
          </th>
          <th>
            Reactants
          </th>
          <th>
            Products
          </th>
          <th>
            k<sub>298</sub> cm<sup>-3</sup> molecule<sup>-1</sup> s<sup>-1</sup>
          </th>
          <th>
            &Delta; log k
          </th>
          <th>
            expression
          </th>
          <th>
            &Delta; (E/R)
          </th>
          <th>
            Temperature range
          </th>
          <th>
            pH range
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="datasheet in datasheets">
          <template v-if="datasheet.preferredValues.length==0">
            <tr :key="datasheet.pk.codeCategory + datasheet.pk.datasheetNumber">
              <td class="text-left"><a target="_blank" :href="$prodPrefix+'datasheets/pdf/' + datasheet.pk.codeCategory + datasheet.pk.datasheetNumber + '.pdf'" download> {{ datasheet.pk.codeCategory + datasheet.pk.datasheetNumber }} </a></td>
              <td class="text-left" v-html="datasheet.reactants"></td>
              <td class="text-left" v-html="datasheet.products"></td>
              <td class="text-left" colspan="6">See datasheet</td>
            </tr>
          </template>
          <tr v-for="(preferredValue, index) in datasheet.preferredValues" v-bind:key="preferredValue.idPreferredValue">
            <template v-if="index==0">
              <td class="text-left" :rowspan="datasheet.preferredValues.length"><a target="_blank" :href="$prodPrefix+'datasheets/pdf/' + datasheet.pk.codeCategory + datasheet.pk.datasheetNumber + '.pdf'" download> {{ datasheet.pk.codeCategory + datasheet.pk.datasheetNumber }} </a></td>
              <td class="text-left" :rowspan="datasheet.preferredValues.length" v-html="datasheet.reactants"></td>
              <td class="text-left" :rowspan="datasheet.preferredValues.length" v-html="datasheet.products"></td>
            </template>
            <td class="text-left" v-html="preferredValue.aqueousPhasePreferredValue.k298"></td>
            <td class="text-left" v-html="preferredValue.aqueousPhasePreferredValue.deltaLogK"></td>
            <td class="text-left" v-html="preferredValue.aqueousPhasePreferredValue.kExpression"></td>
            <td class="text-left" v-html="preferredValue.aqueousPhasePreferredValue.deltaLogER"></td>
            <td class="text-left" v-html="preferredValue.aqueousPhasePreferredValue.temperatureRange"></td>
            <td class="text-left" v-html="preferredValue.aqueousPhasePreferredValue.phRange"></td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </header-summary-table>
</v-container>
</template>

<script>
import HeaderSummaryTable from '../components/HeaderSummaryTable.vue';

export default {
  components: {
    HeaderSummaryTable
  },
  name: 'AqueousPhaseSummaryTable',
  props: ['classification', 'category', 'datasheets']
};
</script>

<style scoped>
ul {
   list-style: none;
   padding: 0;
   margin: 0;
}
</style>
